import { defaultRules, inlineRegex } from "simple-markdown"

export const emote = {
  order: defaultRules.text.order,
  match: inlineRegex(/^¯\\_\(ツ\)_\/¯/),
  parse: capture => {
    const [content] = capture

    return {
      type: "text",
      content,
    }
  },
  react: null,
}
